import React from "react";
import Result from "./components/Result";
import Result2 from "./components/Result2";
import Result3 from "./components/Result3";

function Overview() {
  return (
    <div className="flex relative flex-col flex-grow h-full">
      <div className="flex flex-col w-full flex-grow relative space-y-3 py-5">
        <div className="px-5 flex flex-col lg:flex-row space-y-3 lg:space-y-0 lg:space-x-5">
          <div className="w-full min-w-0">
            <Result />
          </div>
          <div className="w-full min-w-0">
            <Result2 />
          </div>
        </div>
        <div className="px-5">
          <Result3 />
        </div>
      </div>
    </div>
  );
}

export default Overview;
